module.exports = window.wp.router;